import axios from "axios";
import { API_BASE_URL } from "../../../config";

export const getActiveHomeUserData = async (userId) =>
{
    try
    {
        const response = await axios.get(`${API_BASE_URL}/api/HomeUserProfile/getUserProfile`, {
            params: {
                userId,
            },
        });
        return response.data;
    } catch (error) 
    {
        console.error("Error fetching getActiveConverstionList:", error);
        throw error;
    }
};
